import React from 'react';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import UnderlyingBox from '../UnderlyingBox';

const GroupView = (props) => {
  const { data, assetClassName } = props;
  const responsiveGroup = [];
  const children = data.underlyingList.map((u) => (
    <Col key={`key_${u.name}`} className={`${assetClassName}__col`}>
      <UnderlyingBox key={u.name} underlying={u} nColumns={6} />
    </Col>
  ));
  responsiveGroup.push(children);

  return <Row className="g-4 px-3">{responsiveGroup}</Row>;
};
GroupView.propTypes = {
  data: PropTypes.shape({
    underlyingList: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  }).isRequired,
  assetClassName: PropTypes.string.isRequired,
};

export default GroupView;
